"use client";
import { FC } from "react";
import { Content } from "@prismicio/client";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import Bounded from "@/components/componentsV2/shared-components/Bounded";
import AccordionSection from "@/app/(landing)/mental-health/components/accordion-section";
import { motion } from "framer-motion";

/**
 * Props for `CharitiesHelplines`.
 */
export type CharitiesHelplinesProps =
  SliceComponentProps<Content.CharitiesHelplinesSlice>;

/**
 * Component for "CharitiesHelplines" Slices.
 */
const CharitiesHelplines: FC<CharitiesHelplinesProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      {slice.variation === "default" ? (
        <div className="">
          <Bounded className="py-20">
            {/* heading */}

            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <PrismicRichText
                field={slice.primary.section_title}
                components={{
                  heading1: ({ children }) => (
                    <h1 className="text-primary text-3xl md:text-4xl xl:text-5xl font-bold md:font-semibold text-center mb-8">
                      {children}
                    </h1>
                  ),
                  label: ({ node, children }) => {
                    if (node.data.label === "Highlight") {
                      return <span className="text-secondary">{children}</span>;
                    }
                  },
                }}
              />
            </motion.div>

            {/* accordion */}

            <motion.div
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.4, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <AccordionSection data={slice.primary} />
            </motion.div>
          </Bounded>
        </div>
      ) : null}
    </section>
  );
};

export default CharitiesHelplines;
